import { Injectable } from '@angular/core';
import { configURI } from '../../../shared/apiUrlConfig';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
@Injectable()
export class ParComplaintsTimelineService {
  url = environment.configURI;
  load;

  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
   }

  //  getTimelineData(complaintId){
  //   return this.httpClient.get(this.url + '/managecomplaints/' + complaintId)
  //     .catch(this.userFriendlyMsgs.errorHandler);
  // }

  getTimelineTableData(complaintId){
    return this.httpClient.get(this.url + '/complaints/transaction/' + complaintId)
      .catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par-complaints-timeline/par-complaints-timeline.service.ts